import React, { useState, useEffect } from "react"

import "./ContainedImg.scss"

interface IProps {
  src: string
  className?: string
  testId?: string
  displaySize?: Quiz.Api.ImageDisplaySize
}

const ContainedImgRaw: React.FC<IProps> = ({src, className: passThroughClassName, testId, displaySize}) => {
  const [ loaded, setLoaded ] = useState(false)

  const className = [
    "neo__containedImg",
    `neo__containedImg--${displaySize ?? "default"}`,
    loaded ? "--loaded" : "--loading",
    passThroughClassName ?? "",
    passThroughClassName ? `${passThroughClassName}--${displaySize ?? "default"}` : "",
  ].join(" ")

  useEffect(() => {
    const img = new Image()
    img.onload = () => { setLoaded(true) }
    img.src = src

    return () => { // cleanup
      img.onload = null
    }
  })

  return (
    <div
      className={className}
      style={{backgroundImage: `url("${src}")`}}
      data-testid={testId} />
  )
}

const ContainedImg: React.FC<IProps> = (props) => { // to load a new image when src changes
  return <ContainedImgRaw key={props.src} {...props} />
}

export default ContainedImg
